
import { computed, defineComponent, PropType } from 'vue'
import { getOpacityColor } from '@/utils/tool'

export default defineComponent({
  name: 'CmTag',

  props: {
    color: {
      type: String,
      default: 'var(--el-color-primary)'
    },
    /** 传'inherit'时, 使用标签文案的色号取0.2透明度 */
    bgColor: {
      type: String,
      // 作为 backgroundColor CSS 属性使用，用语义变量适配深色模式
      default: 'var(--cm-color-card-bg)'
    },
    border: {
      type: Boolean,
      default: true
    }
  },

  setup (props) {
    const style = computed(() => {
      const bgColor = props.bgColor === 'inherit' ? getOpacityColor(props.color, 0.08) : props.bgColor
      return {
        color: props.color,
        backgroundColor: bgColor,
        boxShadow: `0 0 0 1px ${props.border ? props.color : bgColor}`
      }
    })

    return {
      style
    }
  }
})
